import React from "react";
import styles from "./school-information.module.css";
import { Typography } from "antd";
import SchoolStatisticsOverview from "./components/school-statistics-overview/school-statistics-overview";
import SchoolInfoTabs from "./components/school-info-tabs/school-info-tabs";

const SchoolInformation = () => {
  return (
    <div>
      <Typography className={styles.schoolInfoTitle}>
        General School Information
      </Typography>
      <SchoolStatisticsOverview />
      <SchoolInfoTabs />
    </div>
  );
};

export default SchoolInformation;